import { resolveV3 } from '@/endpoints/resolveV3';

export async function getTownships(txt: string) {
  return resolveV3(
    {
      url: `/search/township-county/?query=${txt}`,
    },
    {
      baseUrl: 'itasca',
    }
  );
}
